import { render, staticRenderFns } from "./ffc.vue?vue&type=template&id=83e88be8"
import script from "./ffc.vue?vue&type=script&lang=js"
export * from "./ffc.vue?vue&type=script&lang=js"
import style0 from "./ffc.vue?vue&type=style&index=0&id=83e88be8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports